import { render, staticRenderFns } from "./ShowNews.vue?vue&type=template&id=2ea3aea3&scoped=true&"
import script from "./ShowNews.vue?vue&type=script&lang=js&"
export * from "./ShowNews.vue?vue&type=script&lang=js&"
import style0 from "./ShowNews.vue?vue&type=style&index=0&id=2ea3aea3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea3aea3",
  null
  
)

export default component.exports